import { LabelColor } from '@shared/components';

export const QUESTION_REVIEW_STATUS_COLOR = {
  todo: LabelColor.INFO,
  'in-review': LabelColor.WARNING,
  reviewed: LabelColor.SUCCESS,
  done: LabelColor.SUCCESS,
};

export const QUESTION_REVIEW_STATUS_TEXT = {
  todo: 'Todo',
  'in-review': 'In Review',
  reviewed: 'Reviewed',
  done: 'Done',
};
